import * as ReportsClient from "../clients/ReportsClient"
export default class EvaluationReport {
  constructor(configName, datasetNumber) {
    this.configName = configName
    this.datasetNumber = datasetNumber
  }
  async load(burstCache) {
      var reportFile = await ReportsClient.getEvaluationReport(this.configName, this.datasetNumber, burstCache)
      Object.keys(reportFile).forEach(key => this[key] = reportFile[key])
      this.races.forEach(race => {
        race.distanceInFurlongs = convertDistancesToFurlongs(race.distance)
        race.distanceText = furlongsToMilesAndFurlongs(race.distanceInFurlongs)
        if (race.predictedWinnerOdds) race.predictedWinnerOdds = (1 * race.predictedWinnerOdds).toFixed(0)
      })
  }
  successByLocation() {
    var locationSuccess = {}
    var locationSuccessArr = []
    var locations = []
    this.races.forEach(race => {
      if (!locationSuccess[race.location]) locationSuccess[race.location] = { count: 0, wins: 0, return: 0 }
      if (race.predictionReturn !== 0) {
        locationSuccess[race.location].count++
        locationSuccess[race.location].return += race.predictionReturn
        if (race.predictionReturn > 0) locationSuccess[race.location].wins ++
      }
    })
    Object.keys(locationSuccess).forEach(location => {
      var obj  = {
        location: location
      }
      Object.keys(locationSuccess[location]).forEach(key => obj[key] = locationSuccess[location][key])
      obj.rpr = obj.return / obj.count
      obj.winPercentage = (obj.wins / obj.count).toFixed(2)
      locationSuccessArr.push(obj)
    })

    locationSuccessArr.sort((a,b) => b.winPercentage - a.winPercentage)
    return locationSuccessArr
  }
  successByProperty(property) {
    var successObj = {}
    var successArr = []
    this.races.forEach(race => {
      if (!successObj[race[property]]) successObj[race[property]] = { count: 0, wins: 0, return: 0 }
      if (race.predictionReturn  && race.predictionReturn !== 0) {
        successObj[race[property]].count++
        successObj[race[property]].return += race.predictionReturn
        if (race.predictionReturn > 0) successObj[race[property]].wins ++
      }
    })
    Object.keys(successObj).forEach(property => {
      var obj  = {
        name: property
      }
      Object.keys(successObj[property]).forEach(key => obj[key] = successObj[property][key])
      obj.rpr = obj.return / obj.count
      obj.winPercentage = (obj.wins / obj.count).toFixed(2)
      successArr.push(obj)
    })

    successArr.sort((a,b) => b.winPercentage - a.winPercentage)
    return successArr
  }
}

function convertDistancesToFurlongs (distance) {
  var furlong = 201.168
  var furlongs = (distance / furlong).toFixed(0) * 1
  return furlongs
}

function furlongsToMilesAndFurlongs(furlongs) {
  var miles = Math.floor(furlongs / 8)
  var remainingFurlongs = furlongs % 8
  if(miles > 0) return miles + "m" + remainingFurlongs + "f"
  return remainingFurlongs + "f"
}
